var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isFieldEmpty(_vm.reply))?_c(_vm.currentFieldComponent(_vm.reply.field.type),{tag:"component",attrs:{"reply":_vm.reply}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }